import { render, staticRenderFns } from "./ProductionManagementContainer.vue?vue&type=template&id=681761d6&"
import script from "./ProductionManagementContainer.vue?vue&type=script&lang=js&"
export * from "./ProductionManagementContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports